/* eslint-disable no-restricted-imports */
import * as React from 'react';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@material-ui/core';
import { Theme, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => {
  const { colors, spacing, typography } = theme;

  return {
    tooltip: {
      backgroundColor: colors.bgContrast,
      color: colors.fgContrast,
      padding: spacing(1),
      // todo, this should be caption
      fontSize: typography.pxToRem(12),
    },
    arrow: {
      color: colors.bgContrast,
    },
  };
});

export type TooltipProps = MuiTooltipProps;

/**
 * Tooltips display informative text when users hover over, focus on, or tap an element.
 *
 * ```js
 * import { Tooltip } from 'bento';
 * ```
 * @deprecated Deprecated — use pantry Tooltip instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-tooltip--docs
 * Migration: Replace Tooltip with the pantry Tooltip component.
 */
export const Tooltip: React.FunctionComponent<React.PropsWithChildren<TooltipProps>> = ({
  arrow,
  children,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <MuiTooltip {...rest} classes={{ tooltip: classes.tooltip, arrow: classes.arrow }} arrow>
      {children}
    </MuiTooltip>
  );
};
